module.exports = __webpack_public_path__ + "img/depmap_svg_V58.ef6e582e.svg";